import { render } from "./QBtn.vue?vue&type=template&id=c54d36cc&scoped=true"
import script from "./QBtn.vue?vue&type=script&lang=js"
export * from "./QBtn.vue?vue&type=script&lang=js"

import "./QBtn.vue?vue&type=style&index=0&id=c54d36cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54d36cc"]])

export default __exports__